(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!customElements.get('load-more-products')) {
    customElements.define(
      'load-more-products',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.results = this.closest('results-list');
          this.results?.querySelectorAll('[class*="pagination"]').forEach((el) => {
            el.style.display = 'none';
          });
          this.button?.addEventListener('click', () => this.loadMore());
        }

        async loadMore() {
          const url = this.dataset.nextUrl;
          if (!url || this.loading) return;

          this.loading = true;
          const label = this.button.textContent;
          this.button.disabled = true;
          this.button.textContent = '…';

          try {
            const response = await fetch(url);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const list = this.results.querySelector('.product-grid__item')?.parentElement;
            const items = doc.querySelectorAll('.product-grid__item');

            if (list && items.length) list.append(...items);

            const next = doc.querySelector('load-more-products')?.dataset.nextUrl;
            if (next) {
              this.dataset.nextUrl = next;
              history.replaceState({}, '', url);
            } else {
              this.remove();
            }
          } catch (error) {
            console.error(error);
          } finally {
            this.loading = false;
            this.button.disabled = false;
            this.button.textContent = label;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
